/**
 * Shared design tokens. Radius values are multipliers of theme.shape.borderRadius (4px):
 * controls (buttons, inputs, chips, menu items) = 2 (8px), surfaces (cards, modals, panels) = 3 (12px).
 */
export const RADIUS_CONTROL = 2;
export const RADIUS_SURFACE = 3;

export const SURFACE_BORDER_COLOR = 'rgba(34, 34, 52, 0.06)';
export const SURFACE_SHADOW = '0 1px 2px rgba(34, 34, 52, 0.06), 0 12px 28px -16px rgba(34, 34, 52, 0.16)';
export const MODAL_SHADOW = '0 24px 48px -16px rgba(34, 34, 52, 0.32)';

export const surfaceSx = {
  backgroundColor: 'background.paper',
  borderRadius: RADIUS_SURFACE,
  border: '1px solid',
  borderColor: SURFACE_BORDER_COLOR,
  boxShadow: SURFACE_SHADOW
} as const;

export const modalSx = {
  borderRadius: RADIUS_SURFACE,
  boxShadow: MODAL_SHADOW,
  outline: 'none'
} as const;
